export default "__VITE_ASSET__182c212c__"